import gql from 'graphql-tag'

export const queryContractTypesList = () => {
	return {
		query: gql`
			{
				contract_types: conf_contract_types {
					id
					type
					active
				}
			}
		`,
		update: data =>
			data.contract_types.map(item => ({
				id: item.id,
				type: item.type,
				edit: true,
				active: item.active
			}))
	}
}
